<template>
  <!-- https://michalsnik.github.io/aos/ -->
  <v-container>

        <v-card
      class="mx-auto"
      max-width="550"
    >

     <v-system-bar    color="pink darken-2" dark v-show="$route.path==='/home' || $route.path==='/sets' ? true : false"></v-system-bar>

    <v-app-bar color="#424242" dark dense
      v-show="$route.path==='/home' || $route.path==='/sets' ? true : false">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>

      <!-- v-img max-height="40" max-width="40" src="/favicon.ico">
      </v-img -->

      Microcise

      </v-toolbar-title>
    </v-app-bar>

      <v-expand-transition>
      <v-card  color="grey darken-1"  dark  height="90">
        
        <v-row  dense>  
          <v-col  cols="12" class="ma-0 pa-0" >
                              <v-spacer></v-spacer>
               <v-card-text>
                <p class="ma-0 pa-0 text-h5 text-center" >Frequent 30 second exercises</p>
                <p class="ma-0 pa-0 text-h6 text-center">Stretch and move all day</p>
      
              </v-card-text>
          </v-col>
        </v-row>

        </v-card>    
      </v-expand-transition>

      <v-card  color="grey lighten-5"  dark>


    <div>
        <ol>

          <!-- li v-for="(item, index) in items" :key="item.id">
             {{index}}  {{item.msg}}
          </li -->

        </ol>
    </div>

        <v-row  dense class="text-center">  
          <v-col  cols="12">
            <!-- assume 30 minutes target. 1 minute=3.33% of total -->
            <v-progress-circular :size="300" :width="30" color="rgba(190, 24, 90, 0.6)" :value="todaysDuration*3.33">

                   <!--v-overlay v-if="todaysDuration==0" position: absolute :opacity=0.0 :value=1>
          <v-img src="/icons/microcise-logo4.png" :max-width="300"></v-img>
      </v-overlay -->
                <div class="text-h2 grey--text text--darken-1">{{todaysDuration}} mins today</div>
             </v-progress-circular>
          </v-col>
        </v-row>


    <!-- BUTTONS -->
    <div v-if="signedIn" class="pb-5">
      <div class="text-center">
         <p class="ma-0 pa-0 text-h6 pink--text text--darken-2 text-center" >Next scheduled session: {{nextScheduledSession}}   <v-icon @click.stop="ScheduleModal = true" color="grey darken-2">mdi-help-circle-outline</v-icon></p>
        
      </div>
      <div class="text-center">
        <v-btn width="300" class="ma-2 pa-0 text-center" color="pink darken-2"   outlined 
          @click="$router.push('/sets')">Exercise now</v-btn>
      </div>
      <div class="text-center">
        <v-btn width="300" class="ma-2 pa-0 text-center"  outlined color="pink darken-2" 
          @click="$router.push('/newset')">Create a new session</v-btn>
      </div>


 <v-sheet class="ma-0 pa-4" color="white" height="100%"  max-height=230 min-height=130 tile>
    <v-row class="fill-height"  align="center" justify="center">
            <div class="ma-0 pa-4 text-center">
            
        <p class="ma-0 ml-5 mr-5 pa-0 cGrey--text">
          <b>The easiest way Microcise - <a href="#" @click.stop="NotificationsModal = true">subscribe for hourly reminders</a></b></p>
        <p class="ma-0 ml-5 mr-5 pa-0 cGrey--text">
          Alternatively, use the <b>Exercise now</b> link to start an existing session or <b>Create a new session</b> to build a custom session
        </p>        
      </div>

    </v-row>
  </v-sheet>



    <div class="text-center ">
      <v-dialog

        v-model="ScheduleModal"
        width="600"
      >
        <v-card>
          <v-card-title class="text-h4 grey lighten-2">
            Exercise Reminders
          </v-card-title>


          <v-card-text>
              <p align="center" justify="center" class="ma-0 pa-0 text-body-1">You receive notifications* during the week at the following times</p>
              <p align="center" justify="center" class="ma-0 pa-0 text-body-2">(subscribe to notifications - bell icon bottom right of your screen)</p>
          </v-card-text>
          <v-divider></v-divider>
      

          <v-card-text>            
            <p align="center" justify="center" class="ma-0 pa-0 text-h6">Notification Schedule (Monday-Friday)</p>
            <p align="center" justify="center" class="ma-0 pa-0 text-body-1">07:55 - Early Morning Stretch</p>
            <p align="center" justify="center" class="ma-0 pa-0 text-body-1">08:55 - Start of the Day Stretch</p>
            <p align="center" justify="center" class="ma-0 pa-0 text-body-1">09:55 - Morning Moves!</p>
            <p align="center" justify="center" class="ma-0 pa-0 text-body-1">10:55 - A Mid Morning Stretch</p>
            <p align="center" justify="center" class="ma-0 pa-0 text-body-1">11:55 - Power Move</p>
            <p align="center" justify="center" class="ma-0 pa-0 text-body-1">12:55 - Outdoor Walk</p>            
            <p align="center" justify="center" class="ma-0 pa-0 text-body-1">13:55 - Strengthen!</p>       
            <p align="center" justify="center" class="ma-0 pa-0 text-body-1">14:55 - Afternoon Movement</p>
            <p align="center" justify="center" class="ma-0 pa-0 text-body-1">15:55 - Afternoon Stretch</p>
            <p align="center" justify="center" class="ma-0 pa-0 text-body-1">16:55 - Power Move</p>                       
          </v-card-text>



          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2 pa-0 text-center"
              color="primary"
              text
              @click="ScheduleModal = false"
            >
              close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>




  <div class="text-center ">
      <v-dialog

        v-model="NotificationsModal"
        width="600"
      >
        <v-card>
          <v-card-title class="text-h4 grey lighten-2">
            Microcise Notifications
          </v-card-title>
  
          <v-card-text>
            <p class="ma-0 pa-0 text-h6 text-center" >We all need a little help forming a new habit</p>
            
            <p class="ma-0 pa-0 text-body-1 text-center" >You will receive regular reminders to exercise every hour between 9am to 5pm week days. Our users find this a great way to get into the routine of frequent movement and exercise.</p>

          </v-card-text>
          
          <v-divider></v-divider>

          <!-- v-card-text>
            <p class="ma-0 pa-0 text-body-1  text-center" >Microcise Notifications appear alongside other system notifications. You do not have to have the Microcise web site, or even your browser, open!</p> 
         
            <p class="ma-0 pa-0 text-body-1  text-center" ></p>
          </v-card-text -->


          <v-card-text>
            <p class="ma-0 pa-0 text-h6 text-center pink--text text--darken-2" >Click the bell icon* at the bottom right of this page to subscribe to Microcise notifications</p>
                 

            <v-row  dense>  
          <v-col  cols="5" >
          </v-col>
          <v-col  cols="5" >
              <v-img max-height="50" max-width="50" position="center center" src="/icons/bell_prompt.png"></v-img>
          </v-col>
          <v-col  cols="5" >
          </v-col>  
          </v-row>        
            <p class="ma-0 pa-0 text-body-1 text-center" >Click again to unsubscribe</p>  
            <p class="ma-0 pa-0 body-2 text-center" >*Notifications do not work with Apple Mobile/iPad (iOS) and the icon will not appear</p>
           
        </v-card-text>
        <v-divider></v-divider>
          <v-row  dense>  
            <v-col  cols="1" >
            </v-col>
            <v-col  cols="10" >
              <p class="ma-0 pa-0 cGrey--text body-2" >Tip: Notifications may flash on your desktop then disappear. Better to change in Settings to stay until clicked so you do not miss a session! Click the appropriate link below for more details</p>
            </v-col>         
            <v-col  cols="1" >
            </v-col>                    
          </v-row>

          <v-row  dense>  

            <v-col  cols="4" class="text-center" >
              <a href="https://support.apple.com/en-gb/guide/mac-help/mh40583/mac" target="_blank">Apple Mac</a>
            </v-col>
            <v-col  cols="4" class="text-center">
              <a href="https://support.microsoft.com/en-us/windows/change-notification-and-quick-settings-in-windows-ddcbbcd4-0a02-f6e4-fe14-6766d850f294" target="_blank">Windows 10/11</a>
            </v-col>          
            <v-col  cols="4" class="text-center">
              <a href="https://support.microsoft.com/en-us/microsoft-edge/manage-website-notifications-in-microsoft-edge-0c555609-5bf2-479d-a59d-fb30a0b80b2b" target="_blank">Windows Edge</a>              
            </v-col>
                                 
          </v-row>
  

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2 pa-0 text-center"
              color="primary"
              text
              @click="NotificationsModal = false"
            >
              close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>



<!-- OLD DUAL NOTIFICATIONS MODEL -->
    <div class="text-center ">
      <v-dialog

        width="600"
      >
        <v-card>
          <v-card-title class="text-h4 grey lighten-2">
            Exercise Reminders
          </v-card-title>
  
          <v-card-text>
            <p class="ma-0 pa-0 text-h6 text-center" >We all need a little help forming a new habit</p>
            
            <p class="ma-0 pa-0 text-body-1 text-center" >You will receive regular reminders to exercise every hour between 9am to 5pm weekdays</p>

            <p class="ma-0 pa-0 text-body-1 text-center" >Web apps like Microcise have two ways to notify you:<br/><b>App Notifications</b> and <b>System Notifications</b></p>
          </v-card-text>
          
          <v-divider></v-divider>
          <v-card-title class="text-h5 grey lighten-2 ">
            App Notifications
          </v-card-title>
          <v-card-text>
            <p class="ma-0 pa-0 text-body-1  text-center" >This is the default. As long as you have the Microcise web page open in your browser, you will receive App reminders</p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title class="text-h5 grey lighten-2 ">
            System Notifications
          </v-card-title>
          <v-card-text>
            <p class="ma-0 pa-0 text-body-1  text-center" >These are Web Notifications that appear alongside other system notifications. You do not have to have the Microcise web site, or even your browser, open! This is possibly a prefered solution, however, if you use a <b>corporate computer</b> you may not be able to receive Web Notifications. Neither do they work with Apple Mobile/iPad (iOS)</p>
         
            <p class="ma-0 pa-0 text-body-1  text-center" ></p>
          </v-card-text>


          <v-card-text>
            <p class="ma-0 pa-0 text-h6 text-center" >Subscribe to System/Web Notifications</p>
            <p class="ma-0 pa-0 body-2 text-center pink--text text--darken-2">Click the bell icon at the bottom of this page to subscribe to System notifications</p>
                  <p class="ma-0 pa-0 body-2 text-center" >Click again to unsubscribe</p>       

            <v-row  dense>  
          <v-col  cols="5" >
          </v-col>
          <v-col  cols="5" >
              <v-img max-height="50" max-width="50" position="center center" src="/icons/bell_prompt.png"></v-img>
          </v-col>
          <v-col  cols="5" >
          </v-col>  
          </v-row>        

           <p class="ma-0 pa-0 body-2 text-center" >When subscribed to Web notifications, you will not receive App notifications. When you unsubscribe, you default back to App notifications</p>
        </v-card-text>
          <v-row  dense>  
            <v-col  cols="1" >
            </v-col>
            <v-col  cols="10" >
              <p class="ma-0 pa-0 body-2" >Tip: System Notifications may flash on your desktop, then disappear. Better to change in Settings to stay until clicked so you do not miss a session!</p>
            </v-col>         
            <v-col  cols="1" >
            </v-col>                    
          </v-row>

          <v-row  dense>  

            <v-col  cols="4" class="text-center" >
              <a href="https://support.apple.com/en-gb/guide/mac-help/mh40583/mac" target="_blank">Apple Mac</a>
            </v-col>
            <v-col  cols="4" class="text-center">
              <a href="https://support.microsoft.com/en-us/windows/change-notification-and-quick-settings-in-windows-ddcbbcd4-0a02-f6e4-fe14-6766d850f294" target="_blank">Windows 10/11</a>
            </v-col>          
            <v-col  cols="4" class="text-center">
              <a href="https://support.microsoft.com/en-us/microsoft-edge/manage-website-notifications-in-microsoft-edge-0c555609-5bf2-479d-a59d-fb30a0b80b2b" target="_blank">Windows Edge</a>              
            </v-col>
                                 
          </v-row>
    
         

      
          <p class="ma-0 mt-5 pa-2  text-body-1 grey lighten-3 grey--text text--darken-2">
            We suggest you try both types to see which works best for you. By default we use App notifications. Tip: With App notifications keep a separate browser window open for Microcise so you do not miss any reminders. 
          </p>


          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2 pa-0 text-center"
              color="primary"
              text
              @click="NotificationsModal = false"
            >
              close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>


    </div>


    <div v-else>   

      <div class="text-center">
        <v-btn width="250" class="ma-2 pa-0 text-center"   outlined color="pink darken-2" 
          @click="$router.push('/auth?action=signIn')">Sign In</v-btn>
      </div>
          <div class="text-center grey--text darken-2">
        Not a member? <v-btn width="50" class="ma-2 pa-0 text-center"  plain color="pink darken-2" 
          @click="$router.push('/auth?action=signUp')">Sign up</v-btn>
      </div>

    </div>


    </v-card>    

<!-- Notification Messages -->
<div class="text-center">
  <!-- v-btn
        dark
        @click="showNotification = true"
      >
        Open Snackbar
      </v-btn -->
      <v-snackbar
        v-model="showNotification"
        min-width=480
        absolute top
        class="white--text"
        color="purple darken-2"
        text
      >
        {{ notificationMessage }}
  
        <template v-slot:action="{ attrs }">
          <v-btn
          dark
            color="pink darken-2"
            v-bind="attrs"
            @click="GoToSession()"
          >
            Start session
          </v-btn>
        </template>
      </v-snackbar>
    </div>


<!-- taken out for now - we are just using system notifications -->
    <!-- v-bottom-navigation v-if="dualNotifications" v-model="value" height="50">
      <v-row  dense class="mt-1 ml-1 pa-0" >  
         <v-col  cols="2" class="ma-0 pt-2 pa-0 text-center" >
            <p class="body-1 pa-0 grey--text text--darken-3">Reminders</p>
        </v-col>
        <v-col  cols="3" class="ma-0 pt-2 pa-0 text-right"  >
            <p class="body-2 ">
              <v-icon  v-if="!userSubscribed" color="pink darken-2">mdi-cellphone-message</v-icon>
              <v-icon  v-else color="grey lighten-1">mdi-cellphone-message</v-icon>
              <span v-if="!userSubscribed" class="pink--text text--darken-2" >App </span>
              <span v-else class="grey--text text--darken-2" >App </span>
            </p> 


        </v-col>
        <v-col  cols="4" class="ma-0 pt-2 pa-0 text-center" >
            <p class="body-2">
              <v-icon  v-if="userSubscribed" color="pink darken-2" >mdi-message-badge</v-icon> 
              <v-icon v-else  color="grey lighten-1" >mdi-message-badge</v-icon>
              <span v-if="!userSubscribed" class="grey--text text--darken-2" >System</span>
              <span v-else class="pink--text text--darken-2" >System</span>
          </p>
        </v-col>     
        <v-col  cols="3" class="ma-0 pt-2 pa-0 text-right" >
          <v-btn value="recent"  @click.stop="NotificationsModal = true">
              <p class="body-2 grey--text text--darken-3"><v-icon  color="grey darken-1 ">mdi-cog</v-icon> Change</p>
          </v-btn>
        </v-col>  
        <v-col  cols="1" class="ma-0 pa-0" >
            <v-icon>mdi-help-circle-outline</v-icon>
        </v-col>                                     
      </v-row>
    </v-bottom-navigation -->


  </v-card>






<v-navigation-drawer class="grey lighten-4"
  v-model="drawer"
  absolute
  bottom
  temporary>
  <v-list nav dense>
    <v-list-item-group
      v-model="group"
      active-class="deep-purple--text text--accent-4"
    >
      <v-list-item @click.stop="$router.push('/sets')">
        <v-list-item-icon>
          <v-icon>mdi-playlist-play</v-icon>
          <span>Sessions</span>
        </v-list-item-icon>    
      </v-list-item>
      <v-list-item @click.stop="$router.push('/list')">
        <v-list-item-icon>
          <v-icon>mdi-playlist-plus</v-icon>
          <span>New session</span>
        </v-list-item-icon>    
      </v-list-item>

      <v-list-item @click.stop="$router.push('/activity')">
        <v-list-item-icon>
          <v-icon>schedule</v-icon>
          <span>Activity</span>
        </v-list-item-icon>   
      </v-list-item>

    <div v-if="signedIn">
      <v-list-item @click="logout()">
        <v-list-item-icon>
          <v-icon>logout</v-icon>
          <span>Sign Out</span>
        </v-list-item-icon>   
      </v-list-item>
      </div>


    </v-list-item-group>
  </v-list>
</v-navigation-drawer>




  </v-container>
</template>

<style>
.v-progress-circular {
margin: 1rem;
}
</style>



<script>
import { Auth } from 'aws-amplify'
import queries from '../api/queries'

/* COMMENT OUT PUBSUB FOR NOW
import Toastification from "./Toastification.vue";
*/

export default {

  name: 'Home',

  data: () => ({
    ScheduleModal: false,
    todaysDuration:0,
    NotificationsModal: false,
    progressOpacity:0.1,
    drawer: false,
    group: null,
    signedIn:false,
    totalForToday: 0,
    currentJWT: "",
    userDetails:null,   
    appID:  "",
    userSubscribed: false,  // to Web Notifications (OneSignal), otherwise use Pub/Sub
    ch1: null,
    showNotification: false,
    notificationMessage: "",
    notificationSetID: null,
    audio: null,
    toastIDs: [],
    dualNotifications: false, // show botton Nav to choose notification type
    value: 'appNotification'  // or webNotification
   
  }),
  beforeCreate() {
    try {
      this.$OneSignal.showSlidedownPrompt();
    } catch (ex) {
            console.log('OneSignal Error: ', ex.message);
    }
    
  },
  async created() {
 

    if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
      this.appID = "c8a72d39-3ec8-4f84-a5a2-5f0e513ca77d"   // Localhost
    } else {
      this.appID = "1950fe5a-27e5-4d9e-9840-3cd63350fdfe"  // remote
    }
    

    //console.log("Home::Created::queries.getActivitiesForToday() - START")
    //let response = await queries.getActivitiesForToday();
    //console.log("getActivitiesForToday. Response")
    //console.log(response)
    //console.log("Home::Created::queries.getActivitiesForToday() - END")

      this.todaysDuration = await queries.getActivityDurationForToday();

  },  
  beforeUpdate() {
  
  },
  updated() {
   
    const self = this;

    // lets check on load if the user is subscribed....
      this.$OneSignal.isPushNotificationsEnabled(function(isEnabled) {

        if (isEnabled) {
          console.log("USER IS SUBSCRIBED")
          self.userSubscribed=true       
        
        }
        else {
          console.log("USER IS NOT SUBSCRIBED")
          self.userSubscribed=false   
        }
         
      });
        
  },  
  async mounted() {


    this.audio = new Audio("microcise-newmessage.wav");
    this.userAuthData = await Auth.currentUserInfo();

    await Auth.currentAuthenticatedUser()
          .then(
              this.signedIn = true
          )
           

      //console.log("USER: " + this.userAuthData.username)

      await this.$OneSignal.init({
      appId: this.appID,
      allowLocalhostAsSecureOrigin: true,
      notifyButton: {
        enable: true,
      },      
    promptOptions: {
      slidedown: {
        prompts: [
          {
            type: "push", // current types are "push" & "category"
            autoPrompt: false,
            text: {

              actionMessage: "We'd like to send you notification reminders to exercise!",
       
              acceptButton: "Allow",
           
              cancelButton: "Cancel"
            }
          }
        ]
      }
    }
    })
 
/* COMMENT OUT PUBSUB FOR NOW
 initialise Pub/Sub
    this.initialisePubSub()  
*/
  
    // important line:
    const self = this;
    // also: OneSignal.push(["getNotificationPermission", function(permissions) {..}]); checking the user permissions. Permissions parameter can be "default", "granted" and "denied".

    // lets check on load if the user is subscribed....
    this.$OneSignal.isPushNotificationsEnabled(function(isEnabled) {

      if (isEnabled) {
        //console.log("**** Push notifications are enabled!");
        self.userSubscribed=true       
        //console.log("STATUS: " + self.userSubscribed)
      }
      else {
        //console.log("**** Push notifications are not enabled yet.");  
        //console.log("So enable Pub/Sub")
        self.userSubscribed=false   
      }
        //console.log("STATUS: " + self.userSubscribed)
    });


    // we also have to capture any subscription changes during their session....
    this.$OneSignal.on('subscriptionChange', function(isSubscribed) {
    //console.log("The user's subscription state is now:", isSubscribed);
      if(isSubscribed) {
        //console.log("User now subscribed to web notifications, so removing Pub/Sub")
         //self.$OneSignal.setExternalUserId(self.userAuthData.username); 
         

         // remove Pub/Sub
         //
         // not sure what is stopping the subscription from firing the message!!!!
         //
          //self.$pnUnSubscribe({
          //  channels: ['ch1']
          //});
         
         self.userSubscribed=true   
         //console.log("STATUS: " + self.userSubscribed)

        // force a page reload - not sure it works/is any use!
        // this.$router.go()
        }
      else {
        //console.log("User now unsubscribed from web notifications, so adding Pub/Sub")

        self.userSubscribed=false   
        //console.log("STATUS: " + self.userSubscribed)

        // force a page reload - not sure it works/is any use!
        //this.$router.go()
      }

      });



 


    },
   computed: {
    
   
    nextScheduledSession: function () {

      const d = new Date();
      let day = d.getDay()
      let hour = d.getHours();
      let scheduledHour="";


      if (day==0 || day>5) {
        scheduledHour="Monday @ 08:00"
      } else {
        if (hour>=24 || hour<7 ) {
          scheduledHour="08:00"
        }
        if (hour>16 || hour<24 ) {
          if(day==5) {
            scheduledHour="Monday @ 08:00"
          } else {
            scheduledHour="Tomorrow @ 08:00"
          }
          
        }

        switch(hour) {    
          case 7:
            scheduledHour="08:00"
            break;
          case 8:
            scheduledHour="09:00"
            break;
          case 9:
            scheduledHour="10:00"
            break;
          case 10:
            scheduledHour="11:00"
            break;
          case 11:
            scheduledHour="12:00"
            break;
          case 12:
            scheduledHour="13:00"
            break;
          case 13:
            scheduledHour="14:00"
            break;
          case 14:
            scheduledHour="15:00"
            break;
          case 15:
            scheduledHour="16:00"
            break;
          case 16:
            scheduledHour="17:00"
            break;
        }

      }

      return (scheduledHour);
    },
    


    },  
  methods: {

    async logout() {
        await  Auth.signOut();
        // refresh the page
        this.$router.go()

      },


/* COMMENT OUT PUBSUB FUNCTIONS FOR NOW........

      initialisePubSub() {
      // Pubnub - subscribe to channel ch1
        this.$pnSubscribe({
            channels: ['ch1']
        });

       //sample message
       // {
       //   "setID":"132b3587-f5df-4d86-a0a8-bb6e1fbff2dd",
       //   "text":"Early morning stretch"
       // }
      
        this.$pnGetMessage('ch1', (message)=>{ 
          
          this.showMessage(message); 
        });
      },




      showMessage(msg) {
     
        this.notificationMessage = msg.message.text
        this.notificationSetID = msg.message.setID 

        // only show pub/sub messages when Web Notifications are not chosen
        if(!this.userSubscribed) {
          

          // https://github.com/Maronato/vue-toastification/tree/main#render-a-component-with-props-and-events
          const content = {
              // Your component or JSX template
              component: Toastification,

              // Props are just regular props, but these won't be reactive
              props: {
                  notificationTitle: this.notificationMessage,
                  notificationSetID: this.notificationSetID
              },

              // Listeners will listen to and execute on event emission
              listeners: {

                  goToSession: ( 
                    (setID) =>  {
                      this.toastIDs.forEach(element => {
                          this.$toast.dismiss(element);
                      });
                      this.GoToSession(setID);
                    }
                    )
              }
          };



          let toastId=this.$toast(content);
          this.toastIDs.push(toastId);

          try {
            this.audio.play();
          } catch (ex) {
              console.log('Audio error: ', ex.message);
          }

        }
        
      },

*/
      GoToSession() {
          this.showNotification=false
          this.$router.push({path: '/session', query : { setID: this.notificationSetID}}); 
      },
      showNotificationPrompt() {
        try {
              this.$OneSignal.showSlidedownPrompt();
            } catch (ex) {
              console.log('OneSignal Error: ', ex.message);
          }
      },
    getTimeinHoursAndMinutes(duration){

      var minutes = Math.floor(duration / 60);
      minutes= Math.round(minutes + Number.EPSILON)

    return(minutes);
    },    
    async getSessionTotalForToday() {

      if(this.signedIn ) {
        let totalToday = this.$store.getters.getSessionTotalToday;
        this.totalForToday = totalToday; 
      } else {
 
        this.totalForToday="?"
      }

    }
  }          
}
</script>


<style>
.max-width-chip.v-chip {
  max-width: 70px;
  min-width: 70px;
}


    /* Applied to a wrapper div when using a custom component as content */
    .Vue-Toastification__toast-component-body.text-style {
        
        font-size: 30px;
    }

.Vue-Toastification__toast--default.text-style {
  max-width: 80%;
  min-width: 80%;
  max-height: 60px;
  min-height: 60px;
  padding:  5px;
}


.max-width-chip .v-chip__content {
  line-height: 32px;
  display: inline-block !important;
  white-space: nowrap;
  overflow: hidden;
   text-overflow: ellipsis;
  position: relative;
}

</style>
